/* eslint-disable no-shadow */
import {
  BRAND_GET_BRAND_BY_ID,
  BRAND_GET_SERVICEABLE_BRANDS,
  BRAND_GET_DELIVERY_POINTS_BY_BRAND_ID,
} from './getters.type';
import { APICRMGET, APIGET, APIPOST } from '../utils/apiHelper';

// initial state
const state = {
  brands: [
    {
      id: 1,
      lang: 'hu',
      imgPath: 'alcatel.png',
      linkUrl: 'https://www.alcatelmobile.com/hu/',
      mapInfo: 'alcatel.mapInfo',
      brandName: 'Alcatel',
      availableDesc: 'alcatel.availableDesc',
      unavailableDesc: '',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.tablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 5,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.watches',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 3,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.smartDevices',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 3,
      lang: 'hu',
      imgPath: 'asus.png',
      linkUrl: 'https://www.asus.com/hu/',
      mapInfo: 'asus.mapInfo',
      brandName: 'Asus',
      availableDesc: 'asus.availableDesc',
      unavailableDesc: 'asus.unavailableDesc',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.tablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 4,
      lang: 'hu',
      brandName: 'Blaupunkt',
      imgPath: 'blaupunkt.png',
      availableDesc: '',
      unavailableDesc: '',
      mapInfo: 'blaupunkt.mapInfo',
      linkUrl: 'link_url',
      productGroups: [],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 6,
      lang: 'hu',
      brandName: 'CAT, Kodak, Land Rover',
      imgPath: 'bullitt_group.png',
      availableDesc: '',
      unavailableDesc: '',
      mapInfo: 'cat.mapInfo',
      linkUrl: 'link_url',
      productGroups: [],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 9,
      lang: 'hu',
      brandName: 'Evolveo',
      imgPath: 'evolveo.png',
      availableDesc: '',
      unavailableDesc: '',
      mapInfo: 'evolveo.mapInfo',
      linkUrl: 'link_url',
      productGroups: [],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 10,
      lang: 'hu',
      brandName: 'GoPro',
      imgPath: 'go_pro.png',
      linkUrl: 'link_url',
      availableDesc: 'gopro.availableDesc',
      unavailableDesc: 'gopro.unavailableDesc',
      mapInfo: 'gopro.mapInfo',
      productGroups: [
        {
          brandProductGroupId: 8,
          productGroupIsAvailable: 1,
          productGroupDesc: 'gopro.prodDesc',
          productGroupTitle: 'products.actionCams',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 4,
          productGroupIsAvailable: 1,
          productGroupDesc: 'gopro.prodDesc',
          productGroupTitle: 'products.otherAccess',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [],
    },
    {
      id: 11,
      lang: 'hu',
      brandName: 'GSmart',
      imgPath: 'gsmart.png',
      availableDesc: '',
      unavailableDesc: '',
      mapInfo: 'gsmart.mapInfo',
      linkUrl: 'link_url',
      productGroups: [],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 12,
      lang: 'hu',
      brandName: 'HTC',
      imgPath: 'htc.png',
      availableDesc: '',
      unavailableDesc: '',
      mapInfo: 'htc.mapInfo',
      linkUrl: 'link_url',
      productGroups: [],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 14,
      lang: 'hu',
      brandName: 'Huawei',
      imgPath: 'huawei.png',
      availableDesc: '',
      unavailableDesc: 'huawei.unavailableDesc',
      mapInfo: 'huawei.mapInfo',
      linkUrl: 'link_url',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.tablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 7,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.notebooks',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 5,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.watchesAndBands',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 10,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.network',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 4,
          productGroupIsAvailable: 1,
          productGroupDesc: 'products.freeBuds',
          productGroupTitle: 'products.cellphoneAccess',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 16,
      lang: 'hu',
      brandName: 'Lenovo',
      imgPath: 'lenovo_black.png',
      availableDesc: '',
      unavailableDesc: 'lenovo.unavailableDesc',
      mapInfo: 'lenovo.mapInfo',
      linkUrl: 'link_url',
      productGroups: [
        {
          brandProductGroupId: 7,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.ideaNotebooks',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 15,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.ideaDesktop',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 22,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.ideaAllInOne',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.ideaTablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 22,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.ideaMonitorAndVr',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [],
    },
    {
      id: 17,
      lang: 'hu',
      brandName: 'LG',
      imgPath: 'lg.png',
      availableDesc: '',
      unavailableDesc: 'lg.unavailableDesc',
      mapInfo: 'lg.mapInfo',
      linkUrl: 'link_url',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.tablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 5,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.watches',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 24,
      lang: 'hu',
      brandName: 'Samsung',
      imgPath: 'samsung.png',
      availableDesc: '',
      unavailableDesc: 'samsung.unavailableDesc',
      mapInfo: 'samsung.mapInfo',
      linkUrl: 'link_url',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 2,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.tablets',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 5,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.gear',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 4,
          productGroupIsAvailable: 1,
          productGroupDesc: 'products.gearStuffs',
          productGroupTitle: 'products.cellphoneAccess',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 21,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cameras',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
    {
      id: 28,
      lang: 'hu',
      brandName: 'Xiaomi',
      imgPath: 'xiaomi.png',
      availableDesc: '',
      unavailableDesc: 'xiaomi.unavailableDesc',
      mapInfo: 'xiaomi.mapInfo',
      linkUrl: 'link_url',
      productGroups: [
        {
          brandProductGroupId: 1,
          productGroupIsAvailable: 1,
          productGroupDesc: '',
          productGroupTitle: 'products.cellphones',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
        {
          brandProductGroupId: 3,
          productGroupIsAvailable: 1,
          productGroupDesc: 'xiaomi.ecoDesc',
          productGroupTitle: 'products.ecoProducts',
          productGroupServices: [
            {
              productGroupServiceID: 1,
              productGroupServiceTitle: 'productGroupServiceTitle',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl',
            },
            {
              productGroupServiceID: 2,
              productGroupServiceTitle: 'productGroupServiceTitle 2',
              productGroupServiceLinkUrl: 'productGroupServiceLinkUrl 2',
            },
          ],
        },
      ],
      deliveryPoints: [
        {
          deliveryPointId: 1,
          deliveryPointName: 'Samsung szervizpont',
          deliveryPointColor: 'FFFFFF',
          brandDeliveryPointId: 1,
          deliveryPointCordLat: '47,451082',
          deliveryPointCordLng: '18,966447',
          deliveryPointContactEmail: 'info@tmx.hu',
          deliveryPointContactPhone: 'contact_phone',
          deliveryPointOpeningHours: 'H-P 9:30 - 19:00, Szo 10:00 - 14:00 V: ZÁRVA',
        },
      ],
    },
  ],
  availableBrands: [],
};

// getters
const getters = {
  //
};

// actions
const actions = {
  async callBrands(context, credentials) {
    const response = await APIGET('brands/hu');
    // console.log(response);
    context.commit('setAvailableBrands', response.data);
  },
  /***
   *
   * showProductGroupOfBrand
   *
   * @param context
   * @param credentials: int - brand.id
   * @returns {Promise<{data: [], message: string, status: number}>}
   */
  async showProductGroupOfBrand(context, credentials) {
    const response = await APICRMGET(`brands/${credentials}/product-groups`);
    return response.data;
  },
  /***
   *
   * showProductTypeOfBrand
   *
   * @param context
   * @param credentials: { brandId: int, productGroupId: int }
   * @returns {Promise<{data: [], message: string, status: number}|{data: [], message: string, status: number}|undefined>}
   */
  async showProductTypeOfBrand(context, credentials) {
    // return await APIPOST(`brands/product-types`, { brandId: credentials.brandId, productGroupId: credentials.productGroupId});
    // const response = await APICRMGET(`brands/${credentials.brandId}/product-types/${credentials.productGroupId}`);
    const response = await APIGET(`brands/${credentials.brandId}/product-types/hu`);
    // console.log(response);
    return response;
  },
  async [BRAND_GET_BRAND_BY_ID](context, brandId, lang = 'hu') {
    const brand = await context.state.brands.find(brand => brand.id == brandId);
    return brand;
  },
  async [BRAND_GET_SERVICEABLE_BRANDS](context) {
    try {
      const response = await APIGET('services/Webportal/ListAllServiceableBrand');
      if (response) {
        return response;
      }
      return { error: true, message: 'HIBA' };
    } catch (err) {
      return { error: true, message: 'HIBA' };
    }
  },
  async [BRAND_GET_DELIVERY_POINTS_BY_BRAND_ID](context, brandId, lang = 'hu') {
    try {
      const response = await APIGET(`services/Webportal/ListDeliveryPoints/${brandId}/${lang}`);
      if (response) {
        return response;
      }
      return { error: true, message: 'HIBA' };
    } catch (err) {
      return { error: true, message: 'HIBA' };
    }
  },
};

// mutations
const mutations = {
  setAvailableBrands(state, credentials) {
    state.availableBrands = credentials;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
